"use strict";

//Reset scroll top

// history.scrollRestoration = "manual";
// jQuery(window).on('beforeunload', function(){
// jQuery(window).scrollTop(0);
// });

var ytid;
jQuery(window).ready(function ($) {
  var screenSizeName = getScreenSizeName();
  var phone = 600;
  var phablet = 890;
  var tablet = 1024;
  var tablet_landscape = 1024;
  jQuery(window).scroll(function (e) {
    var el = jQuery('.header_wrap');
    if (jQuery(this).scrollTop() > 0) {
      el.addClass('header_wrap__bs');
    } else {
      el.removeClass('header_wrap__bs');
    }
  });

  // Hamburger menu
  $('.hamburger').on('click', function () {
    $(this).toggleClass('is-active');
    $('.main-menu').slideToggle('slow');
  });

  // var coll = document.getElementsByClassName("collapsible");
  // var i;
  //
  // for (i = 0; i < coll.length; i++) {
  // 	coll[i].addEventListener("click", function() {
  // 		this.classList.toggle("active");
  // 		var content = this.nextElementSibling;
  // 		if (content.style.maxHeight){
  // 			content.style.maxHeight = null;
  // 		} else {
  // 			content.style.maxHeight = content.scrollHeight + "px";
  // 		}
  // 	});
  // }

  // Product accordion

  // $('.product_box_cmp__box__copy').hide();

  // $('.product_box_cmp__box__btn:not(.no-expand)').click(function() {
  // 	if ($(this).hasClass("active")) {
  //
  // 		$(this).parents( ".product_box_cmp__box" ).css( "z-index", "initial" );
  // 		$(this).removeClass("active").next(".product_box_cmp__box__copy").css( "display", "none" );
  // 		$(".product_box_cmp__mask").fadeOut(10);
  // 	} else {
  // 		$(".product_box_cmp__box__copy").css( "display", "none" );
  // 		$(".product_box_cmp__box__btn .active").removeClass("active");
  // 		$(this).addClass("active");
  // 		// Add the mask
  // 		$(".product_box_cmp__mask").fadeIn();
  // 		$(this).parents( ".product_box_cmp__box" ).css( "z-index", "15" );
  // 		$(this).next(".product_box_cmp__box__copy").css( "display", "block" );
  // 	}
  // 	return false;
  // });

  $('.closespan').click(function () {
    var idElement = $(this).data('item');
    var productElement = $('[data-item="item__' + idElement + '"]');
    if (productElement.hasClass("active")) {
      productElement.closest(".product_box_cmp__box").css("z-index", "initial");
      productElement.closest('.product_box_cmp__box__btn').removeClass("active").next(".product_box_cmp__box__copy").css("display", "none");
      $(".product_box_cmp__mask").fadeOut(10);
      if (window.innerWidth <= tablet) {
        $([document.documentElement, document.body]).animate({
          scrollTop: productElement.offset().top - 200
        }, 500);
      }
    }
    return false;
  });

  // Vertical List

  $('.fb__vertical-list__item__icon').on('click', function () {
    var relatedItem = "." + $(this).data('item');
    var bodyItemHeight = $(relatedItem).css('max-height');
    if (parseInt(bodyItemHeight) > 0) {
      $(relatedItem).css('max-height', '0px');
      $(this).find('img').css({
        'transform': 'rotate( 0deg)'
      });
    } else {
      $(relatedItem).css('max-height', $(relatedItem).prop('scrollHeight'));
      $(this).find('img').css({
        'transform': 'rotate( 45deg)'
      });
    }
  });
  $('.post__filter').on('click', function (e) {
    var url = new URL(window.location);
    var clickedButton = $(this);
    var sectorType = clickedButton.val();
    var postType = $('.inspiration-page').attr('data-postType');
    var postTypeNonce = $('.post__filters').attr('data-nonce');
    $('.post__search--result').removeClass('searching');
    jQuery('html, body').animate({
      scrollTop: $('.post__title-and-filter').offset().top - 110
    }, 'slow');
    jQuery.ajax({
      type: "POST",
      url: myAjax.ajax_url + '?' + Math.floor(Date.now() / 1000),
      dataType: 'json',
      data: {
        action: "get_posts_by_type",
        nonce: postTypeNonce,
        post_type: postType,
        sector_type: sectorType,
        page: 1
      },
      beforeSend: function beforeSend() {
        $('.post__items').empty().html('<span class="cg__loader"><img src="' + CG__settings.themeUrl + '/assets/images/icons/loader.gif" /></span>');
      },
      success: function success(response) {
        if (response.success) {
          $('.post__items').html(response['data']['posts']);
          $('.post__pagination').html(response['data']['pagination']);
          // console.log(response['data']['posts']);
          window.history.pushState({}, null, response['data']['post_type_path']);
          if (sectorType !== 'all') {
            url.searchParams.set('sector', sectorType);
            window.history.pushState({}, '', url);
            url.searchParams.set('sector', sectorType);
          } else {
            url.searchParams["delete"]('sector');
          }
        } else {
          // no results to show
        }
      }
    });
  });
  $('.post__pagination').on('click', '.pagination a', function (e) {
    e.preventDefault();
    var url = new URL(window.location);
    var postSearchTerm = $('#post-search-input').val();
    var clickedButton = $(this);
    var targetPage = clickedButton.attr('data-page');
    var postType = $('.inspiration-page').attr('data-postType');
    var sectorType = $("input:radio[name='sector_type']:checked").val();
    var postNonce = $('.post__filters').attr('data-nonce');
    var postAction = 'get_posts_by_type';
    var searchTerm = null;
    var searchNonce = null;
    var stillSearching = $('.post__search--result').hasClass('searching');
    if (postSearchTerm && postSearchTerm !== '' || stillSearching) {
      searchNonce = $('.post__search--bar').attr('data-nonce');
      postAction = 'get_posts_by_search_term';
      sectorType = null;
      if (stillSearching) {
        searchTerm = $('.post__search--result-term').html();
      } else {
        searchTerm = postSearchTerm;
      }
    }
    jQuery('html, body').animate({
      scrollTop: $('.post__items-wrapper').offset().top - 110
    }, 'slow');
    jQuery.ajax({
      type: "POST",
      url: myAjax.ajax_url,
      dataType: 'json',
      data: {
        action: postAction,
        nonce: postNonce,
        search_nonce: searchNonce,
        post_type: postType,
        sector_type: sectorType,
        page: targetPage,
        searchTerm: searchTerm
      },
      beforeSend: function beforeSend() {
        $('.post__items').empty().html('<span class="cg__loader"><img src="' + CG__settings.themeUrl + '/assets/images/icons/loader.gif" /></span>');
      },
      success: function success(response) {
        if (response.success) {
          $('.post__items').html(response['data']['posts']);
          $('.post__pagination').html(response['data']['pagination']);
          window.history.pushState({}, null, clickedButton.attr('href'));
          if (sectorType !== 'all') {
            url.searchParams.set('sector', sectorType);
          } else {
            url.searchParams["delete"]('sector');
          }
        } else {
          // no results to show
        }
      }
    });
  });
  $('.post__search--button').on('click', function (e) {
    $(this).toggleClass('searching');
    $('.post__title-and-filter').toggleClass('searching');
    $('.post__filters').toggleClass('searching');
    var postSearchBar = $('.post__search--bar');
    postSearchBar.toggleClass('searching');
    if (postSearchBar.hasClass('searching')) {
      $('#post-search-input').focus();
      $('.post__items-wrapper--overlay').addClass('searching');
    } else {
      $('.post__items-wrapper--overlay').removeClass('searching');
      $('#post-search-input').val('');
    }
  });
  $(document).on('keypress', function (e) {
    if ($('#post-search-input').is(':focus') && e.which === 13) {
      $('.post__search--submit').trigger('click');
    }
  });
  $('.post__search--submit').on('click', function (e) {
    e.preventDefault();
    var url = new URL(window.location);
    var postSearchInput = $('#post-search-input');
    var postSearchTerm = postSearchInput.val();
    var postSearchTermNonce = $('.post__search--bar').attr('data-nonce');
    if (postSearchTerm && postSearchTerm !== '') {
      jQuery('html, body').animate({
        scrollTop: $('.post__items-wrapper').offset().top - 110
      }, 'slow');
      jQuery.ajax({
        type: "POST",
        url: myAjax.ajax_url,
        dataType: 'json',
        data: {
          action: "get_posts_by_search_term",
          search_nonce: postSearchTermNonce,
          searchTerm: postSearchTerm
        },
        beforeSend: function beforeSend() {
          $('.post__items').empty().html('<span class="cg__loader"><img src="' + CG__settings.themeUrl + '/assets/images/icons/loader.gif" /></span>');
          $('.post__items-wrapper--overlay').removeClass('searching');
          $('.post__filter').each(function () {
            $(this).prop('checked', false);
          });
        },
        success: function success(response) {
          if (response.success) {
            $('.post__items').html(response['data']['posts']);
            $('.post__pagination').html(response['data']['pagination']);
            $('.post__search--result').addClass('searching');
            $('.post__search--result-count').html(response['data']['found_posts']);
            $('.post__search--result-term').html(response['data']['search_term']);
            window.history.pushState({}, null, response['data']['post_type_path']);
            var _url = new URL(window.location);
            _url.searchParams.set('search', postSearchTerm);
            window.history.pushState({}, '', _url);
          } else {
            // no results to show
          }
        }
      });
    } else {
      postSearchInput.focus();
    }
  });
  $(window).on("popstate", function (e) {
    location.reload();
  });
  var video = document.querySelector('#video');
  var videoYT = document.querySelector('#youtube-video');
  var closeBtn = document.querySelector('.video__btn__close');
  var mask = document.querySelector('.mask');
  if (videoYT) {
    // youtube video player
    ytid = $('#youtube-video').attr('data-ytid');
    if (ytid !== null) {
      var tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  //$( ".video__image" ).on( "click", function() {
  if (jQuery('.play-button').length) {
    $(".play-button").on("click", function () {
      $(this).hide();
      $('.video__image').hide();
      $(".mask, .video__btn__close").css('display', 'block');
      $(".video__movie").show();
      $(".video__cell").removeClass('video__movie--shrink').addClass('video__movie--grow');
      if (video) {
        video.play();
      }
      if (videoYT) {
        playVideo();
      }
    });
  }
  if (video || videoYT) {
    if (video) {
      video.addEventListener('ended', stopMediaInline);
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', stopMediaInline);
    }
    mask.addEventListener('click', stopMediaInline);
  }
  function stopMediaInline() {
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
    if (videoYT) {
      resetVideo();
    }
    $(".mask, .video__btn__close").css('display', 'none');
    $(".video__cell").removeClass('video__movie--grow').addClass('video__movie--shrink');
    $(".video__movie").hide();
    $(".video__image").show();
    $(".play-button").show();
    return false;
  }

  // scroll to element on url hash
  if (window.location.hash) {
    var hash = window.location.hash;
    if ($(hash).length) {
      if ($(hash).hasClass('fb__portfolio-grid__article')) {
        $('html, body').animate({
          scrollTop: $(hash).offset().top - 100
        }, 500, 'linear');
        $(hash).children('a').first().trigger('click');
      }
    }
  }
  $(document).keyup(function (e) {
    if (e.key === "Escape") {
      // escape key maps to keycode `27`
      stopMedia();
    }
  });
  if (jQuery('.glide').length) {
    new Glide(document.querySelector('.glide'), {
      type: 'sliders',
      startAt: 0,
      perView: 1,
      focusAt: 'center',
      keyboard: true,
      gap: 0
    }).mount();
  }
  if (jQuery('.scroller').length) {
    jQuery('.scroller').slick({
      infinite: true,
      loop: true,
      pauseOnHover: true,
      fade: false,
      draggable: true,
      speed: 200,
      autoplay: true,
      dots: false,
      dotsClass: 'slick-dots',
      autoplaySpeed: 3000,
      arrows: true,
      swipe: true,
      vertical: false,
      verticalSwiping: false,
      slidesToScroll: 0.1,
      cssEase: 'linear',
      slidesToShow: 1,
      centerMode: true,
      variableWidth: true,
      responsive: [{
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });
  }
  if (jQuery('.fb__masonry_slider_gallery').length) {
    var $grid = jQuery('.masonry__grid').masonry({
      itemSelector: '.masonry__item',
      columnWidth: 370,
      gutter: 10
    });

    // layout Masonry after each image loads
    $grid.imagesLoaded().progress(function () {
      $grid.masonry('layout');
    });
    jQuery('.masonry__item').fancybox({
      autoDimensions: false,
      fitToView: false,
      autoSize: false,
      maxWidth: '100%',
      maxHeight: '100%',
      openEffect: 'elastic',
      closeEffect: 'fade',
      nextEffect: 'elastic',
      prevEffect: 'elastic',
      openSpeed: 250
      // tpl:{wrap     : '<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin " style="position:relative"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
      // },
      // helpers: {
      // 	overlay: {
      // 		locked: false
      // 	},
      // 	title : {
      // 		type : 'inside'
      // 	}},
      // beforeLoad: function() {
      // 	this.title = $(this.element).attr('data-caption');            },
      // beforeShow : function() {
      // 	$('.fancybox-wrap').addClass('mediaFancy');
      // },
      // afterClose:  function() {
      //
      // 	 $(this).css('display' , 'block');
      // 	},
    });
    jQuery('.masonry__slider').slick({
      infinite: true,
      loop: true,
      pauseOnHover: false,
      fade: false,
      draggable: true,
      speed: 200,
      autoplay: false,
      dots: false,
      dotsClass: 'slick-dots',
      autoplaySpeed: 3000,
      arrows: true,
      swipe: true,
      vertical: false,
      verticalSwiping: false,
      slidesToShow: 1,
      centerMode: true,
      variableWidth: true
    });
  }
  $('.testimonial-videos').slick({
    slidesToScroll: 1,
    arrows: true,
    cssEase: 'linear',
    nextArrow: '<a href="" class="btn__roundel"><img src="' + CG__settings.themeUrl + '/assets/images/svg/arrow.svg" alt="Right Arrow"></a>',
    prevArrow: ''
  });
  var videoTarget = false;
  var videoType = false;
  var videoMask = document.querySelector('.testimonial-videos__popups');
  var videoMaskClose = document.querySelector('.testimonial-video__popup--close');
  var playingVideo = null;
  var videoPlayer = null;
  if (jQuery('.testimonial-video-play').length) {
    $(".testimonial-video-play").on("click", function () {
      var testimonialVideoButton = $(this);
      var videoTargetID = testimonialVideoButton.attr('data-video-target');
      videoTarget = document.querySelector('#' + videoTargetID);
      $(videoMask).css('display', 'flex');
      $(videoMaskClose).css('display', 'block');
      $(videoTarget).show();
      videoType = $(videoTarget).attr('data-video-type');
      if (videoTarget) {
        console.log;
        if (videoType == 'youtube') {
          videoPlayer = $('#' + videoTargetID + ' iframe');
          videoPlayer.attr('allow', "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; autoplay");
          videoPlayer[0].src += "?autoplay=1";
        } else {
          videoTarget.play();
          videoTarget.addEventListener('ended', stopMedia);
          videoTarget.addEventListener('click', doNothing);
        }
        // videoMaskClose.addEventListener('click', stopMedia);
        videoMask.addEventListener('click', stopMedia);
      }
    });
  }
  function doNothing(e) {
    e.stopPropagation();
    return false;
  }
  function stopMedia() {
    if (videoTarget) {
      if (videoType == 'youtube') {
        videoPlayer[0].src = videoPlayer[0].src.slice(0, -11);
        videoPlayer.attr('allow', "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share");
      } else {
        videoTarget.pause();
        videoTarget.currentTime = 0;
      }
      $(videoMask).css('display', 'none');
      // $(videoMaskClose).css('display','none');
      $(videoTarget).hide();
    }
    return false;
  }
  $('.post-scroller').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    arrows: true,
    nextArrow: '<a class="next-post"><img src="' + CG__settings.themeUrl + '/assets/images/svg/arrow.svg" alt="Right Arrow"></a>',
    prevArrow: '',
    speed: 1000,
    adaptiveHeight: true,
    mobileFirst: true,
    respondTo: 'window',
    responsive: [{
      breakpoint: 1085,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }]
  });
  $('.logos_stripe_cmp').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    speed: 2500,
    mobileFirst: true,
    respondTo: 'window',
    pauseOnHover: true,
    responsive: [{
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 900,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    }]
  });
  $('.buzz--left').slick({
    slidesToScroll: 1,
    variableWidth: true,
    arrows: false,
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 1,
    cssEase: 'linear'
  });
  $('.buzz--right').slick({
    slidesToScroll: 1,
    variableWidth: true,
    arrows: false,
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 1,
    cssEase: 'linear',
    rtl: true
  });
  if (jQuery('.play-circle-01').length) {
    // TweenMax.set(".play-circle-01", {
    // 	rotation: 90,
    // 	transformOrigin: "center"
    // })

    gsap.set(".play-circle-01", {
      rotation: 90,
      transformOrigin: "center"
    });
  }
  if (jQuery('.play-circle-02').length) {
    // TweenMax.set(".play-circle-02", {
    // 	rotation: -90,
    // 	transformOrigin: "center"
    // })

    gsap.set(".play-circle-02", {
      rotation: -90,
      transformOrigin: "center"
    });
  }
  if (jQuery('.play-perspective').length) {
    // TweenMax.set(".play-perspective", {
    // 	// xPercent: 6.5,
    // 	// scale: .175,
    // 	transformOrigin: "center",
    // 	perspective: 1
    // })

    gsap.set(".play-perspective", {
      // xPercent: 6.5,
      // scale: .175,
      transformOrigin: "center",
      perspective: 1
    });
  }
  if (jQuery('.play-video').length) {
    // TweenMax.set(".play-video", {
    // 	visibility: "hidden",
    // 	opacity: 0,
    // })
    gsap.set(".play-video", {
      visibility: "hidden",
      opacity: 0
    });
  }
  if (jQuery('.play-triangle').length) {
    // 		TweenMax.set(".play-triangle", {
    // // 	transformOrigin: "left center",
    // // //	transformStyle: "preserve-3d",
    // // 	rotationY: 10,
    // // 	scaleX: 2
    // 			display: "block"
    // 		})

    gsap.set(".play-triangle", {
      display: "block"
    });
  }
  if (jQuery('.play-circle-01').length) {
    var rotateTL = gsap.timeline({
      paused: true
    }).to(".play-circle-01", .7, {
      opacity: .1,
      rotation: '+=360',
      strokeDasharray: "456 456",
      ease: Power1.easeInOut
    }, 0).to(".play-circle-02", .7, {
      opacity: .1,
      rotation: '-=360',
      strokeDasharray: "411 411",
      ease: Power1.easeInOut
    }, 0);
    var rotateInfiniteTL = gsap.timeline({
      repeat: -1,
      yoyo: true
    }).to(".play-circle-01", 1.5, {
      opacity: .1,
      rotation: '+=360',
      strokeDasharray: "456 456",
      ease: Power1.easeInOut
    }, 0).to(".play-circle-02", 1.5, {
      opacity: .1,
      rotation: '-=360',
      strokeDasharray: "411 411",
      ease: Power1.easeIn
    }, 0);
    rotateInfiniteTL.play();
  }

  // Initial Animation

  // TweenMax.from('.header__logo', 1, {
  // 	delay: 1.2,
  // 	opacity: 0,
  // 	x: -20,
  // 	ease: Expo.easeInOut
  // })
  //
  // TweenMax.staggerFrom('.header_menu li', 1, {
  // 	delay: 1.2,
  // 	opacity: 0,
  // 	x: -20,
  // 	ease: Power4.easeInOut,
  // 	//onCompleteAll : function () { console.log("done") }
  // 	}, 0.08
  //   )
  //
  // TweenMax.from('.fb__text', 1, {
  // 	delay: 1.2,
  // 	opacity: 0,
  // 	y: -20,
  // 	ease: Expo.easeInOut
  // })

  //Homepage overlay
  // TweenMax.to('.first', 1.5, {
  // 	delay: .2,
  // 	left: '-100%',
  // 	ease: Expo.easeInOut
  // })
  //
  // TweenMax.to('.second', 1.5, {
  // 	delay: .4,
  // 	left: '-100%',
  // 	ease: Expo.easeInOut
  // })
  //
  // TweenMax.to('.third', 1.5, {
  // 	delay: .6,
  // 	left: '-100%',
  // 	ease: Expo.easeInOut,
  // 	onComplete : function () { document.body.style.height = 'auto'; document.body.style.overflow = 'visible'; }
  // })

  var tl_header = gsap.timeline();
  if (window.innerWidth > phablet) {
    tl_header.from('.header__logo', 0.5, {
      opacity: 0,
      x: -20,
      ease: Expo.easeInOut
    });
    tl_header.staggerFrom('.header_menu li', 0.5, {
      opacity: 0,
      x: -20,
      ease: Power4.easeInOut,
      stagger: 0.08
      //onCompleteAll : function () { console.log("done") }
    }, ">");
  }
  if (jQuery('.fb__text').length) {
    tl_header.from('.fb__text', 1, {
      opacity: 0,
      y: -20,
      ease: Expo.easeInOut
    }, ">");
  }

  // Connect

  // GS Thsi is ok
  if (window.innerWidth > phablet) {
    var tl_connect = gsap.timeline();
    gsap.utils.toArray(".connect--text span").forEach(function (letter, i) {
      var tl_connect_letter = gsap.timeline();
      gsap.to(letter, {
        duration: 1,
        delay: 1,
        top: 0,
        left: 0,
        right: 0,
        position: 'relative',
        zIndex: 0,
        ease: Expo.easeInOut
      });
      tl_connect.add(tl_connect_letter);
    });
  }
  // Home Page Animation
  gsap.registerPlugin(ScrollTrigger);

  // ScrollTrigger.create({
  // 	trigger: ".stage-1",
  // 	start: "top top",
  // 	end: "bottom 150px",
  //
  // 	pin: true,
  //
  // 	//pinType: "fixed",
  // 	pinSpacing: false,
  // 	markers: {startColor: "#39d407", endColor: "#f9ff3d", fontSize: "12px"},
  // });

  // GS This is ok
  gsap.utils.toArray(".fb__text-image__image video").forEach(function (fb__text_image__image, i) {
    gsap.set(".fb__text-image__image", {
      boxShadow: "0px 0px white"
    });
    gsap.from(fb__text_image__image, {
      scrollTrigger: {
        trigger: fb__text_image__image,
        start: "top 30%",
        end: "bottom 60%",
        onEnter: function onEnter() {
          return fb__text_image__image.play();
        },
        //onLeave: () => fb__text_image__image.pause(),
        //markers: {startColor: "green", endColor: "red", fontSize: "12px"},
        //events: onEnter onLeave onEnterback onLeaveBack
        //	toggleActions: "restart none reverse none",
        //options: play, pause, resume, reset, restart, complete , reverse , none
        scrub: true
      },
      boxShadow: "0px 0px transparent"
      //rotation: 360
    });
  });
  // GS This is ok END

  // GS This is ok
  gsap.utils.toArray(".fb__text-image__image img").forEach(function (fb__text_image__image, i) {
    gsap.set(".fb__text-image__image", {
      boxShadow: "0px 0px white"
    });
    gsap.from(fb__text_image__image, {
      scrollTrigger: {
        trigger: fb__text_image__image,
        start: "top 28%",
        end: "bottom 45%",
        //markers: {startColor: "green", endColor: "red", fontSize: "12px"},
        //events: onEnter onLeave onEnterback onLeaveBack
        //	toggleActions: "restart none reverse none",
        //options: play, pause, resume, reset, restart, complete , reverse , none
        scrub: true
      },
      boxShadow: "0px 0px transparent"
      //rotation: 360
    });
  });
  // GS This is ok END

  // GS Thsi is ok
  gsap.utils.toArray(".gs__greyscale img").forEach(function (gs__greyscale, i) {
    gsap.set(".gs__greyscale img", {
      filter: "grayscale(100%)"
    });

    // gsap.set(".gs__greyscale img", {
    // 								webkitFilter:"sepia(100%) hue-rotate(220deg) saturate(50%) brightness(.7)",
    // 								filter: "sepia(100%) hue-rotate(220deg) saturate(50%) brightness(.7)"}
    // );

    gsap.to(gs__greyscale, {
      scrollTrigger: {
        trigger: gs__greyscale,
        start: "top 40%",
        end: "center 70%",
        //	markers: {startColor: "green", endColor: "red", fontSize: "12px"},
        scrub: true
      },
      //filter:"sepia(0%) hue-rotate(0deg) saturate(100%) brightness(1)",
      //webkitFilter:"sepia(0%) hue-rotate(0deg) saturate(100%) brightness(1)",
      filter: "grayscale(0%)"
      //rotation: 360
    });
  });
  // GS This is ok END

  // GS Thsi is ok Hero image
  gsap.utils.toArray(".fb__image img").forEach(function (fb__image, i) {
    gsap.set(".fb__image", {
      boxShadow: "0px 0px white"
    });
    gsap.from(fb__image, {
      scrollTrigger: {
        trigger: fb__image,
        start: "top 30%",
        end: "bottom 60%"
        // markers: {startColor: "green", endColor: "red", fontSize: "12px"},
      },
      boxShadow: "0px 0px transparent"
      //rotation: 360
    });
  });
  // GS This is ok END

  // GS Thsi is ok
  gsap.utils.toArray(".underlined").forEach(function (highlighted_text, i) {
    //gsap.set(".hs", {boxShadow:"0px 0px white"});

    gsap.to(highlighted_text, {
      scrollTrigger: {
        trigger: highlighted_text,
        start: "top 70%",
        end: "bottom 25%"
        //markers: {startColor: "green", endColor: "red", fontSize: "12px"},
      },
      backgroundSize: "100% 100%",
      color: '#FFF',
      padding: '0 0px',
      margin: '0 0px'
    });
  });
  // GS This is ok END

  function animateFrom(elem, direction) {
    direction = direction || 1;
    var x = 0,
      y = direction * 100;
    if (elem.classList.contains("gs_slideIn--fromLeft")) {
      x = -100;
      y = 0;
    } else if (elem.classList.contains("gs_slideIn--fromRight")) {
      x = 100;
      y = 0;
    }
    elem.style.transform = "translate(" + x + "px, " + y + "px)";
    elem.style.opacity = "0";
    gsap.fromTo(elem, {
      x: x,
      y: y,
      autoAlpha: 0
    }, {
      duration: 1.25,
      x: 0,
      y: 0,
      autoAlpha: 1,
      ease: "expo",
      overwrite: "auto",
      stagger: 0.2
    });
  }
  function hide(elem) {
    gsap.set(elem, {
      autoAlpha: 0
    });
  }

  //document.addEventListener("DOMContentLoaded", function() {

  gsap.utils.toArray(".gs__slideIn").forEach(function (elem) {
    hide(elem); // assure that the element is hidden when scrolled into view

    ScrollTrigger.create({
      trigger: elem,
      start: "top 70%",
      end: "bottom 25%",
      //	markers: {startColor: "#b825e2", endColor: "#f31010", fontSize: "12px"},
      onEnter: function onEnter() {
        animateFrom(elem);
      },
      once: true
      //	onEnterBack: function() { animateFrom(elem, -1) },
      //onLeave: function() { hide(elem) } // assure that the element is hidden when scrolled into view
    });
  });
  //});
  // End Home Page animation

  //
  // document.addEventListener("DOMContentLoaded", function() {
  // // Cursor
  // const $bigBall = document.querySelector('.cursor__ball--big');
  // const $smallBall = document.querySelector('.cursor__ball--small');
  // const $hoverables = document.querySelectorAll('.hoverable');
  //
  // // Listeners
  // document.body.addEventListener('mousemove', onMouseMove);
  // for (let i = 0; i < $hoverables.length; i++) {
  // 	$hoverables[i].addEventListener('mouseenter', onMouseHover);
  // 	$hoverables[i].addEventListener('mouseleave', onMouseHoverOut);
  // }
  //
  // // Move the cursor
  // function onMouseMove(e) {
  // 	TweenMax.to($bigBall, .4, {
  // 		x: e.pageX - 15,
  // 		y: e.pageY - 15 });
  //
  // 	TweenMax.to($smallBall, .1, {
  // 		x: e.pageX - 5,
  // 		y: e.pageY - 7 });
  //
  // }
  //
  // // Hover an element
  // function onMouseHover() {
  // 	TweenMax.to($bigBall, .3, {
  // 		scale: 4 });
  //
  // }
  // function onMouseHoverOut() {
  // 	TweenMax.to($bigBall, .3, {
  // 		scale: 1 });
  //
  // }
  //
  // });

  ScrollTrigger.batch(".gs-h-card", {
    start: "top center",
    //markers: {startColor: "#e26d25", endColor: "#f31010", fontSize: "12px"},
    onEnter: function onEnter(elements) {
      gsap.from(elements, {
        autoAlpha: 0,
        y: 60,
        stagger: 0.25
      });
    },
    once: true
  });
  //
  // // usage:
  // batch(".gs-h-card", {
  // 	interval: 0.2, // time window (in seconds) for batching to occur. The first callback that occurs (of its type) will start the timer, and when it elapses, any other similar callbacks for other targets will be batched into an array and fed to the callback. Default is 0.1
  // 	batchMax: 3,   // maximum batch size (targets)
  // 	onEnter: batch => gsap.to(batch, {autoAlpha: 1, stagger: 0.25, overwrite: true}),
  // 	onLeave: batch => gsap.set(batch, {autoAlpha: 0, overwrite: true}),
  // 	onEnterBack: batch => gsap.to(batch, {autoAlpha: 1, stagger: 0.25, overwrite: true}),
  // 	onLeaveBack: batch => gsap.set(batch, {autoAlpha: 0, overwrite: true})
  // 	// you can also define things like start, end, etc.
  // });
  //
  //
  //
  //
  // // the magical helper function (no longer necessary in GSAP 3.3.1 because it was added as ScrollTrigger.batch())...
  // function batch(targets, vars) {
  // 	let varsCopy = {},
  // 		interval = vars.interval || 0.1,
  // 		proxyCallback = (type, callback) => {
  // 			let batch = [],
  // 				delay = gsap.delayedCall(interval, () => {callback(batch); batch.length = 0;}).pause();
  // 			return self => {
  // 				batch.length || delay.restart(true);
  // 				batch.push(self.trigger);
  // 				vars.batchMax && vars.batchMax <= batch.length && delay.progress(1);
  // 			};
  // 		},
  // 		p;
  // 	for (p in vars) {
  // 		varsCopy[p] = (~p.indexOf("Enter") || ~p.indexOf("Leave")) ? proxyCallback(p, vars[p]) : vars[p];
  // 	}
  // 	gsap.utils.toArray(targets).forEach(target => {
  // 		let config = {};
  // 		for (p in varsCopy) {
  // 			config[p] = varsCopy[p];
  // 		}
  // 		config.trigger = target;
  // 		ScrollTrigger.create(config);
  // 	});
  // }

  // document.addEventListener("DOMContentLoaded", function() {
  // 	init_pointer({
  // 		pointerColor: "#E94E19", // Css color
  // 		ringSize: 15, // Pixels
  // 		ringClickSize: 10 // Pixels when clicking
  // 	})
  //
  // })

  // How we connect
  // function moveArrow() {
  // 	gsap.set("#star", {transformOrigin: "right center"})
  //
  // 	gsap.fromTo("#star", {
  // 		x: -50,
  // 		y: 0
  // 	}, {
  // 		delay: 2,
  // 		x: 50,
  // 		y: 60,
  // 		duration: 2,
  // 		ease: "none"
  // 	});
  // }

  if (jQuery('.triangle').length) {
    gsap.timeline({
      scrollTrigger: {
        trigger: ".fb_trinity",
        start: "center 70%",
        end: "bottom top",
        //markers: {startColor: "#ad13e7", endColor: "#f1ee05", fontSize: "12px"},
        scrub: true,
        pin: true
      }
    }).from(".tcreative", {
      y: innerHeight * 1.5
    }).from(".ttech", {
      y: innerHeight * 1.5
    });
  }

  // Experimenbt
  /*
  let bodyScrollBar = Scrollbar.init(document.body, {
  	damping: 0.1,
  	delegateTo: document,
  	alwaysShowTracks: true
  });
  ScrollTrigger.scrollerProxy(".scroller", {
  	scrollTop(value) {
  		if (arguments.length) {
  			bodyScrollBar.scrollTop = value;
  		}
  		return bodyScrollBar.scrollTop;
  	},
  });
  bodyScrollBar.addListener(ScrollTrigger.update);
  
  
  //
  const scroller = document.querySelector('.scroller');
  ScrollTrigger.defaults({ scroller: scroller });
  
  
  
  
  
  gsap.set(".panel", { zIndex: (i, target, targets) => targets.length - i });
  
  var images = gsap.utils.toArray('.panel:not(.purple)');
  
  images.forEach((image, i) => {
  
  	var tl = gsap.timeline({
  
  		scrollTrigger: {
  			trigger: "section.black",
  			scroller: ".scroller",
  			start: () => "top -" + (window.innerHeight*(i+0.5)),
  			end: () => "+=" + window.innerHeight,
  			scrub: true,
  			toggleActions: "play none reverse none",
  			invalidateOnRefresh: true,
  
  			markers: {startColor: "#2a974a", endColor: "#924226", fontSize: "12px"},
  
  		}
  
  	})
  
  	tl
  		.to(image, { height: 0 })
  	;
  
  });
  
  
  
  
  
  
  
  gsap.set(".panel-text", { zIndex: (i, target, targets) => targets.length - i });
  
  var texts = gsap.utils.toArray('.panel-text');
  
  texts.forEach((text, i) => {
  
  	var tl = gsap.timeline({
  
  		scrollTrigger: {
  			trigger: "section.black",
  			scroller: ".scroller",
  			start: () => "top -" + (window.innerHeight*i),
  			end: () => "+=" + window.innerHeight,
  			scrub: true,
  			toggleActions: "play none reverse none",
  			invalidateOnRefresh: true,
  			markers: {startColor: "#f8dd69", endColor: "#a406f3", fontSize: "12px"},
  
  		}
  
  	})
  
  	tl
  		.to(text, { duration: 0.33, opacity: 1, y:"50%" })
  		.to(text, { duration: 0.33, opacity: 0, y:"0%" }, 0.66)
  	;
  
  });
  
  
  
  
  
  ScrollTrigger.create({
  
  	trigger: "section.black",
  	scroller: ".scroller",
  	scrub: true,
  
  	markers: {startColor: "#10ea53", endColor: "#f34806", fontSize: "12px"},
  	pin: true,
  	start: () => "top top",
  	end: () => "+=" + ((images.length + 1) * window.innerHeight),
  	invalidateOnRefresh: true,
  
  });
  
  
  */

  function setActive(elem) {
    jQuery(".step").removeClass('active');
    jQuery(elem).addClass('active');
  }

  // Example 3
  if (jQuery('.fb_trinity_v2b').length) {
    // gsap.timeline({
    // 	scrollTrigger: {
    // 		trigger: ".fb_trinity_v2",
    // 		start: "top 30%",
    // 		end: "bottom top",
    // 		markers: {startColor: "#ad13e7", endColor: "#f1ee05", fontSize: "12px"},
    // 		scrub: true,
    // 		pin: "#container-flex",
    // 		pinSpacing: true
    // 	}
    // })

    //sets up the class toggle on each scrolling text box
    //so that it becomes opaque when in view and transparent when exiting
    gsap.utils.toArray('.step').forEach(function (step) {

      // ScrollTrigger.create({
      // 	trigger: step,
      // 	start: 'top 90%',
      // 	end: 'center top',
      // 	toggleClass: 'active',
      // 	markers: true,
      // 	id: 'toggle-active-class',
      // 	pin: true
      // });
    });

    //This pins the SVG chart wrapper when it hits the center of the viewport
    //and releases the pin when the final textbox meets the bottom of the chart
    //we use a function to define the end point to line up the bottom of the
    //text box with the bottom of the chart
    ScrollTrigger.create({
      trigger: '.fb_trinity_v2',
      endTrigger: '#step-3',
      end: "bottom 50%+=100px",
      start: 'top -200px',
      // end: () => {
      // 	const height = window.innerHeight;
      // 	const chartHeight = document.querySelector('.fb_trinity_v2')
      // 		.offsetHeight;
      // 	return `bottom ${chartHeight + (height - chartHeight) / 2}px`;
      // },
      pin: '.page page-id-403',
      scroller: '.container-flex',
      pinSpacing: true,
      markers: true,
      id: 'chart-pin'
      // onEnter: (self) => { this.style.position = 'fixed';},
      // onEnterBack: (self) => { this.style.position = 'relative'; }
    });

    //The initial animation to show the points
    //sets the point radius to a random value from 0 to 20
    gsap.to('#triangle', {
      scrollTrigger: {
        trigger: '#step-1',
        start: 'top 80%',
        end: 'bottom 50%',
        immediateRender: true,
        toggleActions: 'play none none reverse',
        markers: {
          startColor: "#284ec9",
          endColor: "#284ec9",
          fontSize: "12px"
        },
        id: 'first-box',
        onEnter: function onEnter(self) {
          setActive(self.vars.trigger);
        },
        onEnterBack: function onEnterBack(self) {
          setActive(self.vars.trigger);
        }
      },
      rotation: '60deg',
      top: 0
    });

    //the animation triggered by the second text box
    //shuffles the X position of the points to a random value
    gsap.to('#triangle', {
      scrollTrigger: {
        trigger: '#step-2',
        // start: 'top center',
        // end: 'bottom',
        start: 'top 80%',
        end: 'bottom 50%',
        toggleActions: 'play none none reverse',
        markers: {
          startColor: "#f1ee05",
          endColor: "#f1ee05",
          fontSize: "12px"
        },
        id: 'second-box',
        immediateRender: false,
        onEnter: function onEnter(self) {
          setActive(self.vars.trigger);
        },
        onEnterBack: function onEnterBack(self) {
          setActive(self.vars.trigger);
        }
      },
      rotation: gsap.getProperty("#triangle", "rotation") - 60,
      top: 0
    });

    //the animation triggered by the second text box
    //shuffles the X position of the points to a random value
    gsap.to('#triangle', {
      scrollTrigger: {
        trigger: '#step-3',
        start: 'top center',
        //	end: 'bottom 300px',
        toggleActions: 'play none none reverse',
        //markers: {startColor: "#f9ff3d", endColor: "#f1ee05", fontSize: "12px"},
        id: 'third-box',
        immediateRender: false,
        onEnter: function onEnter(self) {
          setActive(self.vars.trigger);
        },
        onEnterBack: function onEnterBack(self) {
          setActive(self.vars.trigger);
        }
        //toggleClass: 'active',
        // onEnter: () => jQuery('#step-3').addClass('active'),
        // onLeave: () => jQuery('#step-3').removeClass('active'),
      },
      rotation: gsap.getProperty("#triangle", "rotation") - 180,
      top: 0
    });
  }

  // Example 3
  if (jQuery('.fb_trinity_v2c').length) {
    var modules = gsap.utils.toArray('.container-flex');
    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.fb_trinity_v2',
        start: "center center",
        end: "+=300%",
        scrub: 1,
        markers: {
          startColor: "#ad13e7",
          endColor: "#f1ee05",
          fontSize: "12px"
        },
        pin: true
      }
    });
    modules.forEach(function (module, i) {
      console.log("Module " + i);
      // fade in the panels element
      //tl.to(gsap.utils.toArray('#scroll-steps', module), {autoAlpha: 1}, "<")

      var steps = gsap.utils.toArray('.step', module);

      // just for visualizing, randomize the background color of the panels.
      gsap.set(steps, {
        backgroundColor: "rgb(random(0,255), random(0,255), random(0,255))"
      });
      steps.forEach(function (step, i) {
        // first panel should start already in place, and last panel should end in the center.

        console.log("Step " + i);
        tl.to('#triangle', {
          rotation: gsap.getProperty("#triangle", "rotation") + 120
        }, 0);
        tl.to({}, {
          duration: 1
        }); // add some extra space at the end so the last panel sits for a bit before unpinning.
      });
    });
  }

  // Example 3
  if (jQuery('.fb_trinity_v3').length) {
    var rotateTriangle = function rotateTriangle(counter, rtype, obj) {
      counter = jQuery(obj).data('cicle');
      var rotation = 60 + counter * 120;
      gsap.to("#triangle", {
        rotation: rotation + "_short",
        duration: 1,
        ease: "circ"
      });

      //console.log("rotatio " + gsap.getProperty("#triangle", "rotation"));
      //console.log("counter  " + counter + " Type " + rtype);
    };
    var sections = gsap.utils.toArray('.fb_trinity_v3');
    sections.forEach(function (section, i) {
      var modules = gsap.utils.toArray('.module', section);
      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "center center",
          end: "+=100%",
          scrub: true,
          pin: true
          //markers: true
        }
      });

      //console.log(" Nr modules " + modules.length);

      modules.forEach(function (module, i_module) {
        var panels = gsap.utils.toArray('.step', module);
        // just for visualizing, randomize the background color of the panels.
        //gsap.set(panels, {backgroundColor: "rgb(random(0,255), random(0,255), random(0,255))"});

        //	console.log(" Nr pannelli " + panels.length);
        panels.forEach(function (panel, i_panel) {
          tl.to(panel, {
            yPercent: i_panel === 0 ? 0 : -100,
            duration: i === 0 || i === panels.length - 1 ? 0.5 : 1,
            onUpdateParams: [i_panel, '_cw', panel],
            onUpdate: rotateTriangle
          });

          //  tl.fromTo(panel,
          // {
          //  yPercent: i_panel ? 100 : 0,
          //  autoAlpha: 0,
          // }, {
          // 	  yPercent: (i_panel === 0) ? 0 : -100,
          // 	  //  duration: (i_panel === 0 || (i_panel === panels.length ) )  ? 0.5 : 1,
          // 	  ease: "none",
          // 	  onUpdateParams: [i_panel, '_cw', panel],
          // 	  duration: 0.5,
          // 	  onUpdate: hello,
          // 	  autoAlpha: 1
          //   }
          // )
        });
        tl.to({}, {
          duration: 1
        }); // add some extra space at the end so the last panel sits for a bit before unpinning.
      });
    });
  } // if(jQuery('.fb_trinity_v3').length) {

  // Example 3
  if (jQuery('.fb_trinity_v4').length) {
    //sets up the class toggle on each scrolling text box
    //so that it becomes opaque when in view and transparent when exiting
    gsap.utils.toArray('.step').forEach(function (step) {
      ScrollTrigger.create({
        trigger: step,
        start: 'top 80%',
        end: 'center top',
        toggleClass: 'active',
        //markers: true,
        id: 'toggle-active-class'
      });
    });

    //The initial animation to show the points
    //sets the point radius to a random value from 0 to 20
    gsap.to('#trianglef', {
      scrollTrigger: {
        trigger: '#step-1',
        start: 'top center',
        toggleActions: 'play none none reverse',
        //markers: true,
        id: 'first-box'
      },
      rotation: '60deg',
      ease: 'power3.out'
    });

    //the animation triggered by the second text box
    //shuffles the X position of the points to a random value
    gsap.to('#trianglef', {
      scrollTrigger: {
        trigger: '#step-2',
        start: 'top center',
        toggleActions: 'play none none reverse',
        //markers: true,
        id: 'second-box'
      },
      rotation: gsap.getProperty("#triangle", "rotation") - 60,
      duration: 0.5,
      ease: 'power3.inOut'
    });

    //the animation triggered by the second text box
    //shuffles the X position of the points to a random value
    gsap.to('#trianglef', {
      scrollTrigger: {
        trigger: '#step-3',
        start: 'top center',
        id: 'third-box'
      },
      rotation: gsap.getProperty("#triangle", "rotation") - 180,
      duration: 0.5,
      ease: 'power3.inOut'
    });

    //This pins the SVG chart wrapper when it hits the center of the viewport
    //and releases the pin when the final textbox meets the bottom of the chart
    //we use a function to define the end point to line up the bottom of the
    //text box with the bottom of the chart
    ScrollTrigger.create({
      trigger: '.pinme',
      start: "center center",
      end: "+=100%",
      scrub: 1,
      pin: true,
      markers: {
        startColor: "#f8dd69",
        endColor: "#a406f3",
        fontSize: "12px"
      },
      id: 'chart-pin'
    });
  }
  if (jQuery('.fb__parallax-image__section__gs').length) {
    gsap.utils.toArray(".fb__parallax-image__section__gs").forEach(function (section, i) {
      var section_bg = section.querySelector(".fb__parallax-image__bg__gs");
      section_bg.style.backgroundPosition = "50% 0px";
      gsap.to(section_bg, {
        backgroundPosition: "50% ".concat(innerHeight / 2, "px"),
        ease: "none",
        scrollTrigger: {
          trigger: section,
          start: "top top",
          end: "bottom top",
          scrub: true
        }
      });
    });
  }

  // /* Open */
  // function openNav() {
  // 	//document.getElementById("myNav").style.height = "100%";
  // 	jQuery('#overlay_menu').addClass('overlay_menu');
  // }
  //
  // /* Close */
  // function closeNav() {
  // 	//document.getElementById("myNav").style.height = "0%";
  //
  // 	jQuery('#overlay_menu').removeClass('overlay_menu');
  // }

  jQuery('#toggle').click(function () {
    jQuery(this).toggleClass('active');
    jQuery('#overlay_menu').toggleClass('open');
  });
  function getScreenSizeName() {
    var screen_size = window.innerWidth;
    if (screen_size <= 600) return 'phone';
    if (screen_size <= 890) return 'phablet';
    if (screen_size < 900) return 'tablet';
    if (screen_size <= 1024) return 'tablet-landscape';
    return 'container'; // 1250px
  }
  function addEvent(event, selector, callback, context) {
    document.addEventListener(event, function (e) {
      if (e.target.closest(selector)) {
        callback(e);
      }
    });
  }
  if (jQuery('.cmplz-show-banner').length) {
    $('.cmplz-show-banner').click(function (e) {
      $('.cmplz-manage-consent').click();
      return false;
    });
  }
});

// YouTube Global Scope Player functions
var player;
function onYouTubeIframeAPIReady() {
  player = new YT.Player('youtube-video', {
    height: '326',
    width: '545',
    videoId: ytid,
    playerVars: {
      'playsinline': 1,
      'enablejsapi': 1,
      'modestbranding': 1,
      'origin': 'https://v3.carswellgould.test'
    },
    events: {}
  });
}
function playVideo() {
  player.playVideo();
  return true;
}
function stopVideo() {
  player.stopVideo();
  return true;
}
function resetVideo() {
  player.stopVideo(-1);
  return true;
}